import { render, staticRenderFns } from "./ComplianceFooter.vue?vue&type=template&id=2ccbd814&scoped=true"
import script from "./ComplianceFooter.vue?vue&type=script&lang=js"
export * from "./ComplianceFooter.vue?vue&type=script&lang=js"
import style0 from "./ComplianceFooter.vue?vue&type=style&index=0&id=2ccbd814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbd814",
  null
  
)

export default component.exports